"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _digiwashComponents = require("digiwash-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ToggleSwitch(props) {
  let enableBg = props.enableBackgroundColor || "primary.main";
  let disableBg = props.disableBackgroundColor || "gray.light";
  return /*#__PURE__*/_react.default.createElement(_digiwashComponents.Stack, {
    style: {
      width: 40,
      height: 24,
      position: "relative",
      padding: 1,
      borderRadius: 16
    },
    bg: props.selected ? enableBg : disableBg
  }, /*#__PURE__*/_react.default.createElement(_digiwashComponents.Box, {
    bg: "common.white",
    br: "circle",
    style: {
      width: 22,
      height: 22,
      position: "absolute",
      right: props.selected ? null : 1,
      left: props.selected ? 1 : null
    }
  }));
}

var _default = ToggleSwitch;
exports.default = _default;